import React, { PureComponent } from 'react'
import { ScrollView, View } from 'react-native'
import styled from 'styled-components/native'

import { Text } from '../../Atoms/Typography'
import Button from '../../Atoms/Button'
import InlineError from '../../Atoms/InlineError'
import HeaderBar from '../../Molecules/HeaderBar'
import TeamSelection from './TeamSelection'
import FontSelection from './FontSelection'
import HostSelection from './HostSelection'
import GameSelection from './GameSelection'
import Logo from '../../Atoms/Logo'

import theme from '../../../styles/theme'

const Container = styled(View)`
  flex: 1;
  background-color: ${theme.colours.white};
`

const Body = styled(ScrollView)`
  flex: 1;
`

const Footer = styled(View)`
  padding: ${3 * theme.gutterUnit}px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${theme.colours.black};
`

const ButtonGroup = styled(View)`
  flex-direction: row;
`

export default class Settings extends PureComponent {
  render () {
    const {
      error,
      onConfirm,
      onCancel,
      onTeamSelect,
      selectedTeam,
      isMaster,
      onMasterSelect,
      sideBarFontSize,
      registering,
      onSideBarFontSizeSelect,
      onShowDebug,
      onShowErrorLog,
      newHostname,
      onHostNameChange,
      hostType,
      onHostTypeChange,
      hostEnv,
      onHostEnvChange,
      hostRole,
      onHostRoleChange,
      gameId,
      allGames,
      onGameIdChange
    } = this.props
    return (
      <Container>
        <HeaderBar black>
          <Logo />
        </HeaderBar>
        <Body>
          {error && <InlineError message={error.message} />}
          <TeamSelection
            onTeamSelect={onTeamSelect}
            selectedTeam={selectedTeam}
            isMaster={isMaster}
            onMasterSelect={onMasterSelect}
          />
          <HostSelection
            newHostname={newHostname}
            onHostNameChange={onHostNameChange}
            hostType={hostType}
            onHostTypeChange={onHostTypeChange}
            hostEnv={hostEnv}
            onHostEnvChange={onHostEnvChange}
            hostRole={hostRole}
            onHostRoleChange={onHostRoleChange}
          />
          <GameSelection
            hostname={newHostname}
            allGames={allGames}
            gameId={gameId}
            onGameIdChange={onGameIdChange}
          />
          <FontSelection
            sideBarFontSize={sideBarFontSize}
            onSideBarFontSizeSelect={onSideBarFontSizeSelect}
          />
        </Body>
        <Footer>
          <Button darkgrey rounded onPress={onCancel}>
            <Text white>CANCEL</Text>
          </Button>
          <ButtonGroup>
            <Button third rounded onPress={onShowErrorLog}>
              <Text white>ERROR LOG</Text>
            </Button>
            <Button third rounded onPress={onShowDebug} styles={[{ marginLeft: theme.gutterUnit }]}>
              <Text white>DEBUG</Text>
            </Button>
            <Button third rounded onPress={onConfirm} inProgress={registering} styles={[{ marginLeft: theme.gutterUnit }]}>
              <Text white>CONFIRM</Text>
            </Button>
          </ButtonGroup>
        </Footer>
      </Container>
    )
  }
}
